import * as React from 'react';
import { ConsentModal as ConsentModalComponent } from '@appsource/components/modals/consentModal';
import { createInstructionsModalAction, createDriveModalAction, createUserSignOutAction, createUpdateUserProfileLicenseAction } from '@shared/actions/actions';
import { getAppDetail, getUserAuthStatus, updatePurchaseStatus, sendLeadInfo, getAppPricing } from '@shared/actions/thunkActions';
import { getTelemetryDetailContentCurrentView } from '@shared/utils/appUtils';
import { connect } from 'react-redux';
import { withRouter } from '@shared/routerHistory';
export const mapStateToProps = (state, ownProps)=>{
    const { users, config: { locale, billingCountryCode, nationalCloud, flightCodes, featureFlags, embedHost, currentView, currentGalleryViewIsCurated } } = state;
    const { profile, isLoadingUserProfile } = users;
    return {
        locale,
        userInfo: users,
        userProfile: profile,
        isNationalCloud: nationalCloud,
        billingCountryCode,
        flightCodes,
        featureFlags,
        query: ownProps === null || ownProps === void 0 ? void 0 : ownProps.query,
        embedHost,
        currentView: getTelemetryDetailContentCurrentView(currentView, currentGalleryViewIsCurated),
        modal: state.modal,
        isLoadingUserProfile
    };
};
export const mapDispatchToProps = (dispatch)=>{
    return {
        updatePurchaseStatus: ()=>dispatch(updatePurchaseStatus()),
        openInstructionsModal: ()=>dispatch(createInstructionsModalAction({
                showModal: true,
                isFromDownload: true
            })),
        openDriveModal: (driveUrl)=>dispatch(createDriveModalAction({
                showModal: true,
                driveUrl
            })),
        fetchAppDetails: (targetApp)=>dispatch(getAppDetail(targetApp.entityId, false)),
        fetchAppPricing: ({ entityId })=>dispatch(getAppPricing(entityId)),
        sendLeadInfo: ({ item, ctaType, notes, planId })=>dispatch(sendLeadInfo({
                item,
                ctaType,
                notes,
                planId
            })),
        getUserAuthStatus: ()=>dispatch(getUserAuthStatus()),
        signOutUser: ()=>dispatch(createUserSignOutAction(null)),
        updateLicense: (licenseType, license)=>dispatch(createUpdateUserProfileLicenseAction({
                licenseType,
                license
            }))
    };
};
export const ConsentModal = withRouter(connect(mapStateToProps, mapDispatchToProps)(ConsentModalComponent));
